/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RetweetIcon = ({ width = 24, height = 24, hidden = false, title = 'Retweet' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M12 24V14h2a.5.5 0 0 0 .4-.8L9 6l-5.4 7.2a.5.5 0 0 0 .4.8h2v10a6 6 0 0 0 6 6h12l-4.759-6ZM32 22h-2V12a6 6 0 0 0-6-6H12l4.735 6H24v10h-2a.5.5 0 0 0-.4.8L27 30l5.4-7.2a.5.5 0 0 0-.4-.8Z"
    />
  </svg>`;
};
